import React, { Component } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { Tabs, Alert, Button } from "antd";
import NotificationDescription from "../Notifications/NotificationDescription";

class StudentDescription extends Component {
  render() {
    return (
      <div style={{ marginTop: "" }}>
        {this.props.type == "notification" ? (
          <NotificationDescription
            code="COLLEGE_ACADEMIC_NOTICE"
            title="Student Notifications"
          />
        ) : null}
        {this.props.type == "downloads" ? (
          <NotificationDescription
            code="COLLEGE_DOWNLOADS"
            title="Student Downloads"
          />
        ) : null}
        {this.props.type == "routines" ? (
          <NotificationDescription
            code="CLASS_ROUTINES"
            title="Class Routines"
          />
        ) : null}
        {this.props.type == "results" ? (
          <NotificationDescription code="EXAM_RESULTS" title="Exam Results" />
        ) : null}
        {this.props.type == "exam-schedule" ? (
          <NotificationDescription code="EXAM_SCHEDULE" title="Exam Schedule" />
        ) : null}
        {this.props.type == "clubs" ? (
          <NotificationDescription code="STUDENT_CLUBS" title="Student Clubs" />
        ) : null}

        {this.props.type == "certificates" ? <ApplyForCertificates /> : null}
      </div>
    );
  }
}

export default StudentDescription;

export const Notification = (props) => {
  return (
    <div>
      <Typography variant="h4" style={{ margin: "1em 0" }} gutterBottom>
        {props.title}
      </Typography>
      <hr />

      <Typography variant="body1" gutterBottom>
        notifications
      </Typography>
    </div>
  );
};

export const ApplyForCertificates = () => {
  return (
    <div>
      <Typography variant="h4" style={{ margin: "1em 0" }} gutterBottom>
        Apply for Certificates
      </Typography>

      <Alert
        banner
        type="info"
        message={
          <Typography variant="body1">
            You can apply for various online certificates like - Bonafide
            Certificate, Provisional Pass Certificate, Transfer Certificate,
            Charecter Certificate through the following link. The steps to apply
            these certificate: 
            <br />
            <br />Step 1: Visit the link: &nbsp;
            <a target="_blank" href={`https://certificate.dispurcollege.ac.in`}>certificate.dispurcollege.ac.in</a> 
            <br />Step 2: Fillup the form with proper
            values and a valid email. and click on "Submit". You will be
            redirected to payment portal where you need to make the payment.
            <br />Step 3: After the payment, a receipt will be generated and your
            certificate will be processed by the office. 
            <br />Step 4: You will be
            notified on successful generation of the certificate via email.
          </Typography>
        }
      />

      <br />

      <Button type="primary" target="_blank" href={`https://certificate.dispurcollege.ac.in`}>Visit Certificate Portal</Button>
    </div>
  );
};

export const Downloads = (props) => {
  return (
    <div>
      <Typography variant="h4" style={{ margin: "1em 0" }} gutterBottom>
        {props.title}
      </Typography>
      <hr />

      <Typography variant="body1" gutterBottom>
        Downloads
      </Typography>
    </div>
  );
};

const { TabPane } = Tabs;
